import React from 'react';
import { Select } from '@material-ui/core';

interface Props {
  value: luxon.DateTime,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** タクシー・ハイヤー予約画面の日付のセレクトボックスのコンポーネント。 */
export const SelectDay: React.FC<Props> = (props: Props) => {
  /**
   * フォーム上で設定されている月の最終日。
   * （例: 1月の場合は31日、うるう年ではない2月は28日）
   * */
  const lastDay = Number(props.value.daysInMonth);
  /** 「日」部分（1~31までの数値）の配列。 */
  const days = Array.from({length: lastDay}, (_, i) => i + 1);

  /** 初期値。 */
  const defaultValue = props.value.day;

  const setValue = (v: number) => {
    return v.toString().padStart(2, '0');
  }

  return (
    <Select native value={defaultValue} onChange={props.onChange}>
      {
        days.map((d) => {
          return <option value={d} key={`days_${d}`}>{setValue(d)}</option>
        })
      }
    </Select>
  );
}

export default SelectDay;
